<div class="custom-card-container" [ngClass]="{'flex-column': direction === 'column', 'flex-row': direction === 'row'}">
    <div class="card-row" *ngFor="let chunk of chunkedData">
      <ng-container *ngFor="let item of chunk; let i = index">
        <div class="card-item" [ngClass]="{
          'full-width': itemsPerRow === 1 || (direction === 'column' && itemsPerRow !== 'all'),
          'half-width': itemsPerRow === 2,
          'card-holdings-item no-padding': isHoldingsPage,
          'flex-item': itemsPerRow === 'all'
        }">
        <span class="key font-14 margin-4-bottom" [ngClass]="{'font-12': isHoldingsPage}">{{ item.key }}</span>
        <div class="display-flex align-baseline gap-4-px">
          <span class="value" [ngClass]="colorFunction(item.value, item.key, coloredColumns)" 
          [innerHtml]="item.value | formatNumber:true:true:defaultPrecision:true:true"
          [matTooltip]="item.value | formatNumber:true:true:defaultPrecision:false:true">
        </span>
          <span *ngIf="item.suffix" [ngClass]="colorFunction(item.suffix, item.key, coloredColumns)"
            class="font-xs pad-xs-left">
            {{item.suffix | formatNumber:true:false:defaultPrecision}}%
          </span>
        </div>
        </div>
      </ng-container>
    </div>
  </div>